export const appendQuery = (url: string, queryString: string): string => {
  if (!queryString) {
    return url;
  }
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}${queryString}`;
};
